(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-patch-builder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('patch-builder'))customElements.define('patch-builder',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.data=JSON.parse(this.querySelector('[data-patch-data]').textContent);this.order=this.querySelector('[data-order]');this.addEventListener('input',()=>this.update());this.order.addEventListener('submit',e=>{if(this.dataset.preview==='true'||!this.update()){e.preventDefault();this.querySelector('[data-error]').hidden=false;}});this.querySelector('[data-file]').addEventListener('change',e=>{const file=e.target.files[0];const img=this.querySelector('[data-art]');if(this.blob)URL.revokeObjectURL(this.blob);img.hidden=true;if(file&&file.type.startsWith('image/')){this.blob=URL.createObjectURL(file);img.src=this.blob;img.hidden=false;}});this.update();}
update(){const g=s=>this.querySelector('[data-'+s+']');const w=Number(g('width').value),h=Number(g('height').value),q=Number(g('qty').value);const valid=w>=1&&w<=16&&h>=1&&h<=16&&Number.isInteger(q)&&q>=10&&q<=999999;g('error').hidden=valid;g('add').disabled=!valid||this.dataset.preview==='true';if(!valid){g('unit').textContent='—';g('total').textContent='—';return false;}const size=this.data.sizes.find(s=>s>=(w+h)/2);const tier=this.data.tiers.find(t=>q>=t.min&&q<=t.max);const backing=g('backing').value==='Velcro'?'Velcro':'Standard';const key=size+' / '+tier.min+'-'+tier.max+' / '+backing;const variant=this.data.variants[key];if(!variant){g('add').disabled=true;return false;}const money=c=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(c/100);g('variant').value=variant.id;g('size-property').value=size+' in';g('size').textContent=size+'″';g('unit').textContent=money(variant.cents);g('total').textContent=money(variant.cents*q);g('tiers').replaceChildren(...this.data.tiers.map(t=>{const tr=document.createElement('tr');tr.setAttribute('aria-current',String(t===tier));const label=document.createElement('td'),price=document.createElement('td');label.textContent=t.max===999999?t.min+'+':t.min+'–'+t.max;price.textContent=money(this.data.variants[size+' / '+t.min+'-'+t.max+' / '+backing].cents);tr.append(label,price);return tr;}));const quote=g('quote-body');if(!quote.dataset.edited)quote.value=`Custom embroidered patches
Dimensions: ${w} × ${h} inches
Quantity: ${q}
Backing: ${g('backing').value}
Estimated total: ${money(variant.cents*q)}`;quote.oninput=()=>quote.dataset.edited='true';return true;}
disconnectedCallback(){if(this.blob)URL.revokeObjectURL(this.blob);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
